export enum Envs {
  SAAS = 'SAAS',
  SAMOLET = 'SAMOLET',
}
